/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInterestRateRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetInterestRateResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getInterestRate = (request: GetInterestRateRequest, options?: CashRequestOptions) => post<GetInterestRateRequest, GetInterestRateResponse>("/2.0/cash/get-interest-rate", request, {...options, rejectOnError: true })